import { Box } from '@chakra-ui/react'

function IconCheckCircle() {
  return (
    <Box
      boxSize="6"
      sx={{
        background:
          'no-repeat center/contain url("assets/correct-circle-icon.svg")',
      }}
    />
  )
}

export default IconCheckCircle
